import FeatureGates from '@atlaskit/feature-gate-js-client';

// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/post_office_confluence_home_banner_experiment/setup
const POST_OFFICE_HOME_BANNER_STATSIG_EXPERIMENT = 'post_office_confluence_home_banner_experiment';

enum Cohort {
	CONTROL = 'control',
	VARIATION = 'variation',
	NOT_ENROLLED = 'not-enrolled',
}

export const usePostOfficeHomeBannerEligible = () => {
	const cohort = FeatureGates.getExperimentValue<string>(
		POST_OFFICE_HOME_BANNER_STATSIG_EXPERIMENT,
		'cohort',
		Cohort.NOT_ENROLLED,
	);

	return {
		isEligible: cohort === Cohort.VARIATION,
	};
};
